// for scroll animation width inview
$(function() {
  $('.fadeIn-trigger').on('inview', function(event, isInView){
    if (isInView) {
      $(this).addClass('fadeIn');
    }
  });
  $('.fadeInSlow-trigger').on('inview', function(event, isInView){
    if (isInView) {
      $(this).addClass('fadeInSlow');
    }
    else {
      $(this).removeClass('fadeInSlow');
    }
  });
  $('.fadeInBoshuKikan-trigger').on('inview', function(event, isInView){
    if (isInView) {
      $(this).addClass('fadeInBoshuKikan');
    }
    else {
      $(this).removeClass('fadeInBoshuKikan');
    }
  });
  $('.fadeInCatch-trigger').on('inview', function(event, isInView){
    if (isInView) {
      $(this).addClass('fadeInCatch');
    }
    else {
      $(this).removeClass('fadeInCatch');
    }
  });
  $('.fadeInSche-trigger').on('inview', function(event, isInView){
    if (isInView) {
      $(this).addClass('fadeInSche');
    }
    else {
      $(this).removeClass('fadeInSche');
    }
  });
});

// for random hero img
$(function() {
  var elements = [
    '<div id="heroImg" class="fadeIn-hero-img top-bg_chara"></div><div class="hero-img-copylight">©カラー <br>Award:Q 2020 <br class="sp-br">モデリング部門グランプリ作品 <br class="sp-br">『式波・アスカ・ラングレー』</div>',
    '<div id="heroImg" class="fadeIn-hero-img top-bg_mecha"></div><div class="hero-img-copylight">©カラー <br>Award:Q 2020 <br class="sp-br">モデリング部門準グランプリ作品 <br class="sp-br">『明日へ』</div>'
  ];
  var randElm = elements[Math.floor(Math.random() * elements.length)];
  $('.hero-image-wrapper').html(randElm);
});

// for slick slider
$(function() {
  $('.chara').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.chara-nav',
    breakpoint: 641,
    settings: {
      arrows: false,
    }
  });
  $('.chara-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.chara',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true
  });
  $('.mecha').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.mecha-nav',
    breakpoint: 641,
    settings: {
      arrows: false,
    }
  });
  $('.mecha-nav').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    asNavFor: '.mecha',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true
  });
});
